import authApi from '../api/authApi';
import registerApi from '../api/registerApi';
import * as constants from '../constants/constants';
import * as storageHelper from '../functions/storageHelper';
import config from '../libs/webIMConfig';
import creditCard from '../models/creditCard';
import creditCardInfo from '../models/creditCardInfo';
import userModel from '../models/user';
import userService from './userService';

interface ApiResponse<T = any> {
  success: boolean;
  statusCode?: number;
  message: string;
  data?: T;
  status: number;
}

interface UserVCard {
  avatarUrl?: string;
  age?: string | number;
  firstName?: string;
  lastName?: string;
  online?: boolean;
  memberTypeTitle?: string;
  displayName?: string;
}

interface UserData {
  userId?: string;
  xmppId?: string;
  vCard?: UserVCard;
}

interface LoginParams {
  xmppId: string;
  password?: string;
}

interface RHPUser {
  Username?: string;
  Password?: string;
}

interface LoginRHPWebParams {
  Username: string;
  Password?: string;
  SrcType: any;
  Latitude: any;
  Longitude: any;
}

export interface IParamSignInWithFacebook {
  FacebookID: string;
  FacebookAccessToken: string;
}

class authService {
  static createLoginUserModelObject(user: UserData) {
    const { vCard } = user;
    const data = {
      id: user.userId,
      userId: user.userId,
      xmppId: user.xmppId,
      avatarUrl: vCard ? vCard.avatarUrl : '',
      age: vCard ? vCard.age : '',
      location: '',
      firstName: vCard ? vCard.firstName : '',
      lastName: vCard ? vCard.lastName : '',
      favorites: [],
      online: vCard ? vCard.online : false,
      memberTypeTitle: vCard ? vCard.memberTypeTitle : 'Male',
      pinned: [],
      displayName: vCard ? vCard.displayName : '',
      matching: [],
    };
    return userModel.mappingObject(data);
  }

  login({ xmppId, password }: LoginParams) {
    const { REACT_APP_USE_XMPP_CACHED_TOKEN } = process.env;
    let token: string = '';
    if (storageHelper.storageCachingSupported()) {
      token = storageHelper.getKey(constants.SESSIONS.MESSENGER_TOKEN) || '';
    }
    if ((REACT_APP_USE_XMPP_CACHED_TOKEN === 'true' || (!xmppId && !password)) && token && token.length > 0 && token !== 'undefined') {
      config.token = storageHelper.getKey(constants.SESSIONS.MESSENGER_TOKEN) || '';
      return userService.getMyQuickProfile().then((res: any) => {
        const response = res as ApiResponse;
        try {
          if (response.success && response.data) {
            return {
              success: response.success,
              data: { user: response.data },
            };
          }
          console.log('ERROR: authService/login/getMyQuickProfile:', response.message);
          return {
            success: false,
            data: { user: null },
          };
        } catch (e) {
          console.log('ERROR: authService/login/getMyQuickProfile:', e);
          throw new Error('failed');
        }
      });
    }
    return authApi.login(xmppId, password).then((res: any) => {
      const response = res as ApiResponse;
      // console.log("Auth Service call api login", res)
      try {
        if (response.success && response.data) {
          if (response.data.token && response.data.token.length > 0 && response.data.token !== 'undefined') {
            if (storageHelper.storageCachingSupported()) {
              storageHelper.setKey(constants.SESSIONS.MESSENGER_TOKEN, response.data.token);
            }
            config.token = response.data.token;
          }
          response.data.user = authService.createLoginUserModelObject(response.data.user);
        } else {
          console.log('ERROR: authService/login:', response.message);
        }
        return response;
      } catch (e) {
        console.log('ERROR: authService/login:', e);
        throw new Error('failed');
      }
    });
  }

  loginRHP(user: any, rememberMe: any, buildVersion: any, agent: any, identifier: any, reCAPTCHAToken: any) {
    const REACT_APP_USE_RHP_CACHED_TOKEN = process.env.REACT_APP_USE_RHP_CACHED_TOKEN || (config.rqAth ? config.rqAth.toString() : '');
    if (
      storageHelper.storageCachingSupported() &&
      (REACT_APP_USE_RHP_CACHED_TOKEN === 'true' || (!user.Password && !user.Username)) &&
      storageHelper.getKey(constants.SESSIONS.RHP_TOKEN) &&
      storageHelper.getKey(constants.SESSIONS.RHP_REFRESH_TOKEN)
    ) {
      return new Promise<any>(resolve => {
        const bearerToken = storageHelper.getKey(constants.SESSIONS.RHP_TOKEN); // 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImtpZCI6InZIOCJ9.eyJzdWIiOjgwLCJpYXQiOjE1MjIwNzk4OTQsImV4cCI6MTUyMjA4MTY5NCwicHJlZmVycmVkX3VzZXJuYW1lIjoiaG90Y291cGxlIiwicm9sZXMiOlsiVXNlciJdLCJNZW1iZXJJRCI6MjU5MCwiTWVtYmVyTGV2ZWwiOjQsIk1lbWJlclR5cGUiOjR9.uPd7JFprJqg6Q0ERMPi64pk9DuqsebCahxY_OGK1fjc3yf3ah1v1fmeqo2kGjXzChVQtTiFNYCr2bD_unuOxxNMEZqGgCSLCgF77l-y9gRhPqy7K-wWpZSz6K7nH6dpFmp9xEZytNGahysEszOp85KnUb7gQcr47yxK-5ECiZxI';
        const refreshBearerToken = storageHelper.getKey(constants.SESSIONS.RHP_REFRESH_TOKEN); // 'eyJ0eXAiOiJKV1RSIiwiYWxnIjoiUlMyNTYiLCJraWQiOiJ2SDgifQ.eyJzdWIiOjgwLCJpYXQiOjE1MjIwNzk4OTQsImV4cCI6MTUyNDY3MTg5NH0.VCcdTu5tQ4DHjEpgOE7xjccG8q8Jt6TGQe7PihWkDwqAU2eItIqoshZh7usL2ojp2eiqnfywGalIzAAyp-T3YqxS-EIX_1dGCigKO17OI4Ui-6wRH8XHZI9TYaiMbdUxTxmeYwpYl8qg-Q0ZAly2hFyvUvMLqlMYMW3sU-BuFLU';

        if (bearerToken && bearerToken.length > 0) {
          config.stopGettingRhpToken = false;
          config.gettingRhpToken = false;
          if (storageHelper.storageCachingSupported()) {
            storageHelper.setKey(constants.SESSIONS.RHP_TOKEN, bearerToken);
          }
          config.rhpToken = bearerToken;
        }
        if (refreshBearerToken && refreshBearerToken.length > 0) {
          if (storageHelper.storageCachingSupported()) {
            storageHelper.setKey(constants.SESSIONS.RHP_REFRESH_TOKEN, refreshBearerToken);
          }
          config.rhpRefreshToken = refreshBearerToken;
        }

        return resolve(
          Object.assign(
            {},
            {
              data: {
                BearerToken: bearerToken,
                RefreshToken: refreshBearerToken,
                ResponseStatus: {},
              },
              success: true,
              message: '',
              statusCode: 200,
            }
          )
        );
      });
    }
    if (rememberMe && rememberMe.token && rememberMe.refreshToken) {
      config.rhpToken = rememberMe.token;
      config.rhpRefreshToken = rememberMe.refreshToken;

      return new Promise<any>(resolve => {
        resolve(
          Object.assign(
            {},
            {
              data: {
                BearerToken: config.rhpToken,
                RefreshToken: config.rhpRefreshToken,
                ResponseStatus: {},
              },
              success: true,
              message: '',
              statusCode: 200,
            }
          )
        );
      });
    }
    if (!user) {
      return new Promise<any>(resolve => {
        resolve(Object.assign({}, { success: false }));
      });
    }
    return authApi.loginRHP(user, buildVersion, agent, identifier, reCAPTCHAToken).then((res: any) => {
      const response = res as ApiResponse;
      try {
        if (response.success && response.data) {
          if (response.data.BearerToken && response.data.BearerToken.length > 0) {
            config.stopGettingRhpToken = false;
            config.gettingRhpToken = false;
            if (storageHelper.storageCachingSupported()) {
              storageHelper.setKey(constants.SESSIONS.RHP_TOKEN, response.data.BearerToken);
            }
            config.rhpToken = response.data.BearerToken;
          }
          if (response.data.RefreshToken && response.data.RefreshToken.length > 0) {
            if (storageHelper.storageCachingSupported()) {
              storageHelper.setKey(constants.SESSIONS.RHP_REFRESH_TOKEN, response.data.RefreshToken);
            }
            config.rhpRefreshToken = response.data.RefreshToken;
          }
        }
        if (!response.success && !response.message) {
          response.message = 'Invalid login details';
        }
        return response;
      } catch (e) {
        console.log('ERROR: authService/login:', e);
        throw new Error('failed');
      }
    });
  }

  loginRHPWeb({ Username, Password, SrcType, Latitude, Longitude }: LoginRHPWebParams) {
    return authApi.loginRHPWeb({ Username, Password, SrcType, Latitude, Longitude }).then((res: any) => {
      try {
        return res as ApiResponse;
      } catch (e) {
        console.log('ERROR: authService/login:', e);
        throw new Error('failed');
      }
    });
  }

  signInWithFacebook(params: IParamSignInWithFacebook) {
    const fbOAuth = {
      AccessToken: parseInt(params.FacebookID),
      OAuth_Token: params.FacebookAccessToken,
    };
    return registerApi.checkFacebookAccount(fbOAuth).then(async (res: any) => {
      const response = res as ApiResponse;
      //  console.log('Check faecbook',fbOAuth, res);
      // console.log("Facbook info", res)
      if (response.success) {
        if (response.data.BearerToken && response.data.BearerToken.length > 0) {
          if (storageHelper.storageCachingSupported()) {
            storageHelper.setKey(constants.SESSIONS.RHP_TOKEN, response.data.BearerToken);
          }
          config.rhpToken = await response.data.BearerToken;
        }
        if (response.data.RefreshToken && response.data.RefreshToken.length > 0) {
          if (storageHelper.storageCachingSupported()) {
            storageHelper.setKey(constants.SESSIONS.RHP_REFRESH_TOKEN, response.data.RefreshToken);
          }
          config.rhpRefreshToken = await response.data.RefreshToken;
        }
        return { success: true, data: response.data };
      }
      // console.warn("Facebook account not yet register");
      // throw ("failed");
      return {
        success: false,
        statusCode: response.status,
        message: response.message,
        status: response.statusCode,
      };
    });
  }

  signInApple(params: any) {
    const body = {
      AccessToken: params.identityToken,
      AccessTokenSecret: params.authorizationCode,
      nonce: params.nonce,
    };
    return registerApi.signInApple(body, params.isWeb).then(async (res: any) => {
      const response = res as ApiResponse;
      if (response.success) {
        if (response.data.BearerToken && response.data.BearerToken.length > 0) {
          if (storageHelper.storageCachingSupported()) {
            storageHelper.setKey(constants.SESSIONS.RHP_TOKEN, response.data.BearerToken);
          }
          config.rhpToken = await response.data.BearerToken;
        }
        if (response.data.RefreshToken && response.data.RefreshToken.length > 0) {
          if (storageHelper.storageCachingSupported()) {
            storageHelper.setKey(constants.SESSIONS.RHP_REFRESH_TOKEN, response.data.RefreshToken);
          }
          config.rhpRefreshToken = await response.data.RefreshToken;
        }
        return { success: true, data: response.data };
      }
      // console.warn("Can not sign in with Apple Id", res);
      // throw ("failed");
      return {
        success: false,
        statusCode: response.status,
        message: response.message,
        status: response.statusCode,
      };
    });
  }

  signInGoogle(params: { idToken: string }) {
    const body = {
      AccessToken: params.idToken,
    };
    return registerApi.signInGoogle(body).then(async (res: any) => {
      const response = res as ApiResponse;
      if (response.success) {
        if (response.data.BearerToken && response.data.BearerToken.length > 0) {
          if (storageHelper.storageCachingSupported()) {
            storageHelper.setKey(constants.SESSIONS.RHP_TOKEN, response.data.BearerToken);
          }
          config.rhpToken = await response.data.BearerToken;
        }
        if (response.data.RefreshToken && response.data.RefreshToken.length > 0) {
          if (storageHelper.storageCachingSupported()) {
            storageHelper.setKey(constants.SESSIONS.RHP_REFRESH_TOKEN, response.data.RefreshToken);
          }
          config.rhpRefreshToken = await response.data.RefreshToken;
        }
        return { success: true, data: response.data };
      }
      // console.warn("Can not sign in with Google Id", res);
      // throw ("failed");
      return {
        success: false,
        statusCode: response.status,
        message: response.message,
        status: response.statusCode,
      };
    });
  }

  getAnonymousAccessToken() {
    return authApi.getAnonymousAccessToken().then((res: any) => {
      const response = res as ApiResponse;
      if (response.success) {
        if (response.data.Result) {
          config.rhpAnonymousToken = response.data.Result;
        }
        return response;
        // if (res.data.BearerToken && res.data.BearerToken.length > 0) {
        //     config.rhpToken = res.data.BearerToken;
        // }
        // if (res.data.RefreshToken && res.data.RefreshToken.length > 0) {
        //     config.rhpRefreshToken = res.data.RefreshToken;
        // }
        // return res;
      }
      console.warn('AuthService/GetAnonymousAccessToken', response.message);
      throw new Error('failed');
    });
  }

  updateRetainStatus(params: any) {
    return authApi.updateRetainStatus(params).then((res: any) => {
      return res as ApiResponse;
    });
  }

  getCreditCard() {
    return authApi.getCreditCard().then((res: any) => {
      const response = res as ApiResponse;
      if (response.success) {
        return { success: true, data: creditCardInfo.mappingObjects(response.data) };
      }
      return { success: false, data: null };
    });
  }

  deleteCreditCard() {
    return authApi.deleteCreditCard().then((res: any) => {
      const response = res as ApiResponse;
      console.log('red', response);
      if (response.success && response.data && response.data.Result) {
        return { success: true };
      }
      return { success: false };
    });
  }

  updateCreditCard(params: any) {
    const objParams = {
      PurchaseToken: params.purchaseToken,
      Card: creditCard.mappingPropertyObject(params),
      Product: {
        Token: params.token,
      },
    };
    return authApi.updateCreditCard(objParams).then((res: any) => {
      const response = res as ApiResponse;
      if (response.success) {
        if (response.data && response.data.PaymentSuccess) {
          return {
            success: true,
            data: creditCardInfo.mappingObjectAfterUpdate(objParams),
          };
        }
        return {
          success: false,
          message: response.data.ErrorMessage,
          data: null,
        };
      }
      return { success: false, data: null, message: response.message };
    });
  }

  logOut() {
    return authApi.logoutRHP().then((res: any) => {
      // logout
      return res as ApiResponse;
      //  console.log('res logout success', res)
    });
  }
  /*
    * @params
    *   {
             "Username": string,
             "Password": string
        }
    * */
  accountLookUp(userName: any, password: any) {
    let params = {
      Username: userName,
      Password: password,
    };
    return authApi.accountLookup(params).then((res: any) => {
      const response = res as ApiResponse;
      if (response.success) {
        return {
          success: true,
          data: userModel.mappingObjectsMultipleAccount(response.data.items),
        };
      } else {
        return {
          success: false,
          message: response.data.message,
          data: [],
        };
      }
    });
  }
  uploadFaceVerificationVideo(params: any) {
    return authApi.createUserVerificationVideo(params);
  }
}

export default new authService();
